export default __webpack_public_path__ + "static/barrier-3b601525bebbce00f8c988329236e6f4.png";